<div class="json-editor" #editorContainer></div>
